/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon16Regular = forwardRef('CheckA2Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15.768 4.924a.75.75 0 0 0-1.06-1.06l-6.872 6.87a.75.75 0 0 0 1.061 1.06l6.871-6.87Z" }),
        React.createElement("path", { d: "M11.799 4.924a.75.75 0 0 0-1.061-1.06l-6.392 6.39a.837.837 0 0 1-1.184 0L1.299 8.393a.75.75 0 1 0-1.06 1.06L2.1 11.316a2.338 2.338 0 0 0 3.306 0l6.392-6.391Z" })));
});
